export default "Piscines municipales : chauffage, déshumidification, ECS. Plan d'actions décret tertiaire, primes CEE BAT-* et aides locales pour réduire la facture énergétique.";
